import request from '@/common/request'
import { Thread } from '@/models'
import { AxiosRequestConfig } from 'axios'

export const findAll = async (params: any, config?: AxiosRequestConfig): Promise<Thread[]> =>
	request.get(`/threads`, {params: {...params, ...config} })